<template>
  <div>
    <Menu mode="horizontal" :active-name="$route.name" @on-select="selectMenu">
      <MenuItem name="private_cloud_fast_create_server">
        快速创建实例
      </MenuItem>
      <!--<MenuItem name="private_cloud_create_server">-->
        <!--自定义配置-->
      <!--</MenuItem>-->
    </Menu>
  </div>
</template>

<script>
export default {
  name: 'create-menu',
  data () {
    return {

    }
  },
  methods: {
    selectMenu (name) {
      this.$router.push({name: name})
    }
  }
}
</script>

<style scoped>

</style>
